import { Link, useLocation } from "react-router-dom";

export function HashLink({ hash, onClick, ...props }) {
  const loc = useLocation();
  const handle = (e) => {
    onClick?.(e);
    if (loc.pathname === "/" && loc.hash === hash) document.getElementById(hash.slice(1))?.scrollIntoView({ behavior: "smooth" });
  };
  return <Link to={{ pathname: "/", hash }} onClick={handle} {...props} />;
}

export const SmartLink = ({ to, ...props }) => (to.startsWith("#") ? <HashLink hash={to} {...props} /> : <Link to={to} {...props} />);
